import { useState } from "react";
import { SafeHtml } from "@/components/SafeHtml";

export default function SimpleEditor({ value, onChange, placeholder }) {
  const [mode, setMode] = useState("visual"); // visual | html | preview

  return (
    <div className="border rounded-lg overflow-hidden bg-white">
      <div className="flex items-center gap-1 px-3 py-2 border-b bg-slate-50">
        <button type="button" onClick={() => setMode("visual")}
          className={`px-3 py-1 rounded-md text-xs font-medium transition-colors ${mode === "visual" ? "bg-white shadow-sm text-slate-900 border" : "text-slate-400 hover:text-slate-600"}`}>
          Wizualny
        </button>
        <button type="button" onClick={() => setMode("html")}
          className={`px-3 py-1 rounded-md text-xs font-medium transition-colors ${mode === "html" ? "bg-white shadow-sm text-slate-900 border" : "text-slate-400 hover:text-slate-600"}`}>
          HTML
        </button>
        <button type="button" onClick={() => setMode("preview")}
          className={`px-3 py-1 rounded-md text-xs font-medium transition-colors ${mode === "preview" ? "bg-white shadow-sm text-slate-900 border" : "text-slate-400 hover:text-slate-600"}`}>
          Podglad
        </button>
      </div>

      {mode === "visual" && (
        <SafeHtml
          className="min-h-[200px] max-h-[400px] overflow-y-auto p-4 text-sm leading-relaxed focus:outline-none prose prose-sm max-w-none"
          contentEditable
          suppressContentEditableWarning
          onBlur={(e) => onChange(e.currentTarget.innerHTML)}
          html={value || ""}
        />
      )}

      {mode === "html" && (
        <textarea
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder || "Wklej kod HTML artykulu..."}
          className="w-full min-h-[200px] max-h-[400px] p-4 text-sm leading-relaxed focus:outline-none resize-y border-0 font-mono"
          spellCheck={false}
        />
      )}

      {mode === "preview" && (
        <div className="min-h-[200px] max-h-[400px] overflow-y-auto p-6 bg-white">
          {value ? (
            <SafeHtml className="max-w-none
              [&>h1]:text-2xl [&>h1]:font-bold [&>h1]:text-slate-900 [&>h1]:mb-6 [&>h1]:leading-tight
              [&>h2]:text-xl [&>h2]:font-bold [&>h2]:text-slate-800 [&>h2]:mt-8 [&>h2]:mb-4
              [&>h3]:text-lg [&>h3]:font-semibold [&>h3]:text-slate-700 [&>h3]:mt-6 [&>h3]:mb-3
              [&>p]:text-base [&>p]:text-slate-600 [&>p]:leading-relaxed [&>p]:mb-4
              [&>ul]:pl-6 [&>ul]:mb-4 [&>ul]:list-disc
              [&>ul>li]:text-base [&>ul>li]:text-slate-600 [&>ul>li]:mb-2 [&>ul>li]:leading-relaxed
              [&>ol]:pl-6 [&>ol]:mb-4 [&>ol]:list-decimal
              [&>ol>li]:text-base [&>ol>li]:text-slate-600 [&>ol>li]:mb-2
              [&_strong]:text-slate-900 [&_strong]:font-semibold
              [&_a]:text-blue-600 [&_a]:underline [&_a]:hover:text-blue-800
              [&>blockquote]:border-l-4 [&>blockquote]:border-blue-400 [&>blockquote]:pl-4 [&>blockquote]:italic [&>blockquote]:text-slate-500 [&>blockquote]:my-6"
              html={value} />
          ) : (
            <p className="text-sm text-slate-400 italic">Brak tresci do podgladu</p>
          )}
        </div>
      )}
    </div>
  );
}
